import React , { Component } from 'react';
import styled, { css, keyframes } from 'react-emotion';
import { screenWidths } from './../../utils/constants';


const Info = styled.div`
    width: 100%;

    .imgNosotros{
        width: 100%;
        height: 480px;
        object-fit: cover;
    }

    p.text {
        font-family: ZeitungMicroPro-Light;
        line-height: 2em;
        margin-bottom: 2em;
        text-align: justify;
    }
`;

export const Title = styled.h2`
  font-family: ZeitungMicroPro-Light;
  font-weight: normal;
  margin-bottom: 55px;
  font-size: 50px;
  color:  #424149;
  @media screen and (min-width: ${screenWidths.lg}px) {
    text-align: left;
  }
`;

export default class QuienesSomos extends Component {
    render() {
        return (
                <Info>
                    <Title>{this.props.title}</Title>
                    <img className={"imgNosotros"} src={this.props.mainImage} />
                    {this.props.description.split('\n').map((t, i) => <p key={i} className="text">{t}</p>)}                           
                </Info>          
        )
    }    
}


// WEBPACK FOOTER //
// ./src/components/About/QuienesSomos.js